<!--
 * @Author: your name
 * @Date: 2021-05-15 22:21:39
 * @LastEditTime: 2021-05-16 15:28:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vue-demo\src\components\addressSelect.vue
-->
<template>
  <div class="width300">
    <el-popover
      placement="bottom-start"
      width="450"
      trigger="click"
      v-model="showAddressPop"
    >
      <div class="address-box">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="全国" name="all"></el-tab-pane>
          <el-tab-pane
            v-if="selectDataObj.selectProvince"
            :label="selectDataObj.selectProvince"
            name="city"
          ></el-tab-pane>
          <el-tab-pane
            v-if="selectDataObj.selectCity"
            :label="selectDataObj.selectCity"
            name="area"
          ></el-tab-pane>
        </el-tabs>
        <div class="address-info">
          <span
            v-for="item in cityData"
            :key="item.value"
            :id="item.value"
            :class="{ active: item.value == selectDataObj.areaCode }"
            @click="selectAddrItem(item.value, item.text, item.children)"
          >{{ item.text }}</span
          >
        </div>
      </div>
      <el-input
        v-model="addrInfo"
        placeholder="请选择地址"
        slot="reference"
      ></el-input>
    </el-popover>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: "all",
      addrInfo: "",
      showAddressPop: false,
      selectDataObj: {
        areaCode: "",
        selectProvince: "",
        selectCity: "",
        selectArea: "",
      },
      //地区选择数据源
      pads: [],
      cityData: [], //当前选择的数据
      cityDataCopy: [], //之前选择省级、市级数据备件，在用户点击顶部地区tab时，切换对应的选择数据
    };
  },

  // props: {
  //   areaCode: {
  //     type: String,
  //     default: "",
  //   },
  // },
  created() {
    //  this.initCityData(this.areaCode); //封装成组件的话，可以父组件动态传值初始化地址选择数据
    this.initCityData("");
  },
  methods: {
    //初始化城市数据
    initCityData(areaCode = "") {
      let sData = this.pads;
      // 未请求到数据
      if (sData.length < 1) {
        return false;
      }
      let cityDataCopy = this.cityDataCopy;
      cityDataCopy[0] = sData;

      if (!/^\d{6}$/.test(areaCode)) {
        this.cityData = sData;
      } else {
        let cityDataBox = this.cityData; //当前用于选择的城市数据
        let selectDataObj = {
          areaCode: areaCode,
          selectProvince: "",
          selectCity: "",
          selectArea: "",
        };
        //已选中城市初始化
        let stateCode = areaCode.slice(0, 2);
        let cityCode = areaCode.slice(0, 4);
        for (let i = 0; i < sData.length; i++) {
          if (sData[i].value.slice(0, 2) == stateCode) {
            //匹配到省级
            selectDataObj.selectProvince = sData[i].text;
            this.activeName = "city";
            let cData = sData[i].children;
            cityDataCopy[1] = cData;
            for (let j = 0; j < cData.length; j++) {
              if (cData[j].value.slice(0, 4) == cityCode) {
                //匹配到市级
                selectDataObj.selectCity = cData[j].text;
                this.activeName = "area";
                let aData = cData[j].children;
                cityDataBox = aData;
                for (let a = 0; a < aData.length; a++) {
                  if (aData[a].value == areaCode) {
                    // 匹配到区级
                    selectDataObj.selectArea = aData[a].text;
                    break;
                  }
                }
                break;
              }
            }
            break;
          }
        }
        this.cityData = cityDataBox;
        this.selectDataObj = selectDataObj;
      }
      this.cityDataCopy = cityDataCopy;
    },
    // 是直辖市或者港澳台
    isZhiXiaShiOrGangAoTai(stateCode) {
      const cityArr = ["11", "31", "12", "50", "81", "82", "71"];
      return cityArr.indexOf(stateCode) > -1;
    },
    //选择
    selectAddrItem(areaCode, cityName, children) {
      let selectDataObj = this.selectDataObj;
      let cityData = this.cityData;
      let cityDataCopy = this.cityDataCopy;
      //省级名称
      if (areaCode.slice(2, 6) == "0000") {
        selectDataObj.selectProvince = cityName;
        this.activeName = "city";
      } else if (
        //市级名称
        areaCode.slice(2, 4) != "00" &&
        areaCode.slice(4, 6) == "00"
      ) {
        selectDataObj.selectCity = cityName;
        this.activeName = "area";
      } else {
        //区级名称
        selectDataObj.selectArea = cityName;
      }
      //有下级区域则切换到下一级数据
      if (children.length > 0) {
        let isZhiXiaShiOrGangAoTai = this.isZhiXiaShiOrGangAoTai(
          areaCode.slice(0, 2)
        );
        if (isZhiXiaShiOrGangAoTai) {
          cityData = children[0].children;
        } else {
          cityData = children;
        }
        //改变备份数据
        if (cityDataCopy.length < 2) {
          if (isZhiXiaShiOrGangAoTai) {
            cityDataCopy.push(children[0].children);
          } else {
            cityDataCopy.push(children);
          }
        } else {
          if (isZhiXiaShiOrGangAoTai) {
            cityDataCopy.splice(1, 1, children[0].children);
          } else {
            //这里成立说明是三级地区，应该保存当前展示的市级数据(cityData)，而不是要切换后的区级数据（children），因为我们到达最后一级就选完了，我们顶部切换只有全国（所有省份）、市区（当前省份下的市区）
            cityDataCopy.splice(1, 1, this.cityData);
          }
        }
      } else {
        //到达地区最后一级
        selectDataObj.areaCode = areaCode;
        // 保存所有城市信息
        this.submit(selectDataObj);
      }
      this.selectDataObj = selectDataObj;
      this.cityData = cityData;
      this.cityDataCopy = cityDataCopy;
    },
    handleClick(tab, event) {
      const tabName = tab.name;
      if (tabName === "all") {
        this.backProvinceSelect();
      }
      if (tabName === "city") {
        this.backCitySelect();
      }
    },
    // 点击省份选择目录
    backProvinceSelect() {
      this.cityDataCopy = [this.pads];
      this.selectDataObj["selectProvince"] = "";
      this.selectDataObj["selectCity"] = "";
      this.selectDataObj["selectArea"] = "";
      this.cityData = this.pads;
    },
    // 点击城市选择目录
    backCitySelect() {
      this.selectDataObj["selectCity"] = "";
      this.selectDataObj["selectArea"] = "";
      this.cityData = this.cityDataCopy[1];
    },
    submit(data) {
      this.addrInfo = data.selectProvince + data.selectCity + data.selectArea;
      this.showAddressPop = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.width300 {
  width: 300px;
}
.address-info span {
  display: inline-block;
  width: 20%;
  text-align: center;
  margin-bottom: 20px;
  cursor: pointer;
  &.active {
    font-weight: bold;
    color: #970022;
  }
  &:hover {
    font-weight: bold;
    color: #970022;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/test.vue